<script lang="ts">
import { defineComponent } from 'vue'
import { BoxplotChart, BoxplotChartOptions, ChartTabularData } from '@carbon/charts'
import CcvBaseChart from './CcvBaseChart.vue'

interface Props {
	data: ChartTabularData
	options: BoxplotChartOptions
}

export default defineComponent({
	name: 'CcvBoxplotChart',
	extends: CcvBaseChart,
	props: {
		data: {
			type: Object as () => ChartTabularData,
			required: true
		},
		options: {
			type: Object as () => BoxplotChartOptions,
			required: true
		}
	},
	mounted() {
		const { data, options } = this.$props as Props
		this.coreChart = new BoxplotChart(this.$el as HTMLDivElement, { data, options })
	}
})
</script>

<template>
	<div class="ccv-boxplot-chart"></div>
</template>
